(function ($) {
  "use strict";
  jQuery(document).ready(function(){

    /*--
    Menu Sticky
    -----------------------------------*/
    $(window).scroll(function() {
    if ($(this).scrollTop() > 75){  
        $('.header-sticky').addClass("is-sticky");
      }
      else{
        $('.header-sticky').removeClass("is-sticky");
      }
    });
    
    document.onkeydown = function(e) {
      if(event.keyCode == 123) {
       return false;
     }
     if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
       return false;
     }
     if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
       return false;
     }
     if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
       return false;
     }
     if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
       return false;
     }
   }

    /*--
    Mobile Menu
    ------------------------*/
    var menuNav = $('nav.main-navigation');
    menuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });
    $(document).ready(function(){
      $(".shopping-cart a.cart-count").click(function(){
        $(".mini-cart").addClass("show");
        $(".mm-fullscreen-bg").addClass("active");
      });
      $(".shopping-cart-close").click(function(){
        $(".mini-cart").removeClass("show");
        $(".mm-fullscreen-bg").removeClass("active");
      });
      $(".mm-fullscreen-bg").click(function(){
        $(".mini-cart").removeClass("show");
        $(".mm-fullscreen-bg").removeClass("active");
      });
      $("a.meanmenu-reveal").click(function(){
        $(".mean-nav").toggleClass("active");
        $(".is-sticky").toggleClass("active-menu");
      });
      $(".search-icon").click(function(){
        $(".search-block").toggleClass("active");
      });

    });

    $("button.navbar-toggler").click(function(){
      $(".mainmenu").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden"); 
    });
    $(".mm-fullscreen-bg").click(function() {
      $(".mainmenu").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $(".close-box").click(function() {
      $(".mainmenu").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
        /*--
   Sidebar Search Active
   -----------------------------*/
   function sidebarSearch() {
    var searchTrigger = $('.trigger-search'),
    endTriggersearch = $('button.search-close'),
    container = $('.main-search-active');

    searchTrigger.on('click', function() {
      container.addClass('inside');
    });

    endTriggersearch.on('click', function() {
      container.removeClass('inside');
    });

  };
  sidebarSearch();



  /*-- Brand Slider --*/
  var blogSlider = $('.blog-image-slider');
  blogSlider.slick({
    arrows: true,
    autoplay: false,
    dots: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScoll: 1,
    prevArrow: '<button type="button" class="slick-prev"> <i class="icon-arrow-left"></i> </button>',
    nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
  });    
    $('[data-toggle="tooltip"]').tooltip();    
    
    $('.full-view').on('click', function(){
       $('.product_detail_img').magnificPopup('open');
    });
    
    /*--
    Magnific Popup
    ------------------------*/
      
        $('.product_detail_img').magnificPopup({
          delegate: 'a',
          type: 'image',
          showCloseBtn: true,
          closeBtnInside: false,
          midClick: true,
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
          }
        });


    /*--
    Accordion
    -------------------------*/
    $(".faequently-accordion").collapse({
      accordion:true,
      open: function() {
        this.slideDown(300);
      },
      close: function() {
        this.slideUp(300);
      }		
    });	

    $(window).scroll(function(){
      if ($(this).scrollTop() > 1000) {
        $('#top').fadeIn();
      } else {
        $('#top').fadeOut();
      }
    });
    $('#top').click(function(){
      $("html, body").animate({ scrollTop: 0 }, 600);
      return false;
    });
    /* ===================================
    masonry
    ====================================== */

    $('.grid').imagesLoaded(function () {
        $('.grid').isotope({
            itemSelector: 'li',
            layoutMode: 'masonry'
        });
    });
    /* --
    counterUp 
    -----------------------------*/
    $('.count').counterUp({
      delay: 10,
      time: 1000
    });

  });
})(jQuery);